export const fmtDate = (s: string | null | undefined) => (s ? new Date(s).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const fmtNum = (n: number | null | undefined) => (n === null || n === undefined ? '—' : n.toLocaleString());
